import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { POD_PRICE_LIST_PATH } from '../../core/constants';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const deletePodPriceListAction = createAsyncThunk(
    'price/deletePodPriceListAction',
    async (podId, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.delete(`${ POD_PRICE_LIST_PATH }/${ podId }/price-list`);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const deletePodPriceListSlice = createSlice({
    name: 'deletePodPriceListSlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(deletePodPriceListAction.pending, () => STATE__API__STARTED);
        builder.addCase(deletePodPriceListAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(deletePodPriceListAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const deletePodPriceListState = (state) => state.price.deletePodPriceList;
export default deletePodPriceListSlice.reducer;
